import * as APP_ACTION from './actionTypes';

export const initiate = () => ({ type: APP_ACTION.INITIATE });
export const updateDimentions = (payload) => ({
  type: APP_ACTION.UPDATE_DIMENTIONS,
  payload,
});
export const togglePanoMode = (mode) => ({
  type: APP_ACTION.TOGGLE_PANO_MODE,
  payload: mode,
});
export const toggleMenu = (isOpen) => ({
  type: APP_ACTION.TOGGLE_MENU,
  payload: isOpen,
});
export const setMenuPosition = (payload) => ({
  type: APP_ACTION.SET_MENU_POSITION,
  payload,
});
export const setTourData = (payload) => ({
  type: APP_ACTION.SET_TOUR_DATA,
  payload,
});
export const setPanoData = (payload) => ({
  type: APP_ACTION.SET_PANO_DATA,
  payload,
});

export const goToScene = (groupId, id) => ({
  type: APP_ACTION.GO_TO_PANO,
  payload: { id, groupId },
});

export const closeLanding = () => ({ type: APP_ACTION.CLOSE_LANDING });
export const setAerialMapData = (payload) => ({
  type: APP_ACTION.SET_AERIAL_MAP_DATA,
  payload,
});
export const toggleBlur = (payload) => ({
  type: APP_ACTION.TOGGLE_BLUR,
  payload,
});
export const setAudioAvailable = (payload) => ({
  type: APP_ACTION.SET_AUDIO_AVAILABLE,
  payload,
});
export const setAudioAutoPlay = () => ({
  type: APP_ACTION.SET_AUDIO_AUTOPLAY,
});
export const toggleAudio = (isOn) => ({
  type: APP_ACTION.TOGGLE_AUDIO,
  payload: isOn,
});
export const setTourAudioAvailabe = (isOn) => ({
  type: APP_ACTION.SET_TOUR_AUDIO_AVAILABLE,
  payload: isOn,
});
export const setGlobalAudioPlaying = (payload) => ({
  type: APP_ACTION.SET_GLOBAL_AUDIO_PLAYING,
  payload,
});
export const setGlobalAudioSource = (payload) => ({
  type: APP_ACTION.SET_GLOBAL_AUDIO_SOURCE,
  payload,
});
// Hotspots
export const addHotspotHistory = (payload) => ({
  type: APP_ACTION.ADD_HOTSPOT_HISTORY,
  payload,
});

// Control Mode
export const setGyro = (payload) => ({ type: APP_ACTION.SET_GYRO, payload });
export const setControlMode = (payload) => ({
  type: APP_ACTION.SET_CONTROL_MODE,
  payload,
});

export const setCenterLookat = (payload) => ({
  type: APP_ACTION.SET_CENTER_LOOKAT,
  payload,
});

// Landing
export const toggleLanding = (payload) => ({
  type: APP_ACTION.TOGGLE_LANDING,
  payload,
});

export const setTourError = (payload) => ({
  type: APP_ACTION.SET_TOUR_ERROR,
  payload,
});

//View Mode
export const setViewMode = (payload) => ({
  type: APP_ACTION.SET_VIEW_MODE,
  payload,
});

export const setAutoPlay = (payload) => ({
  type: APP_ACTION.SET_AUTO_PLAY,
  payload,
});

export const updatePrevRotation = (payload) => ({
  type: APP_ACTION.UPDATE_PREV_ROTATION,
  payload,
});

export const setAutoRotate = (payload) => ({
  type: APP_ACTION.SET_AUTO_ROTATE,
  payload,
});

export const setSearchParams = (payload) => ({
  type: APP_ACTION.SET_SEARCH_PARAMS,
  payload,
});

export const setOpenPopUp = (payload) => ({
  type: APP_ACTION.SET_OPEN_POPUP,
  payload,
});

export const updateWorldParams = (payload) => ({
  type: APP_ACTION.UPDATE_WORLD_PARAMS,
  payload,
});

export const setPanning = (payload) => ({
  type: APP_ACTION.SET_IS_PANNING,
  payload,
});

export const setLimitOrbit = (payload) => ({
  type: APP_ACTION.SET_LIMIT_ORBIT,
  payload,
});

// World3D Visibility
export const setWorld3DVisible = (payload) => ({
  type: APP_ACTION.SET_WORLD3D_VISIBLE,
  payload,
});

export const setHoverBuildingVisible = (payload) => ({
  type: APP_ACTION.SET_HOVER_BUILDING_VISIBLE,
  payload,
});

export const setInteractiveMapVisible = (payload) => ({
  type: APP_ACTION.SET_INTERACTIVE_MAP_VISIBLE,
  payload,
});

export const setLocationVisible = (payload) => ({
  type: APP_ACTION.SET_LOCATION_VISIBLE,
  payload,
});

export const setModalPage = (payload) => ({
  type: APP_ACTION.SET_MODAL_PAGE,
  payload,
});

// Icon Toggle Buttons
export const toggleEyeButton = (payload) => ({
  type: APP_ACTION.TOGGLE_EYE_BUTTON,
  payload,
});

export const toggleInfoButton = (payload) => ({
  type: APP_ACTION.TOGGLE_INFO_BUTTON,
  payload,
});

// Guide Board
export const setGuideBoardVisible = (payload) => ({
  type: APP_ACTION.SET_GUIDE_BOARD_VISIBLE,
  payload,
});

// Previous Menu Link
export const setPreviousMenuLink = (payload) => ({
  type: APP_ACTION.SET_PREVIOUS_MENU_LINK,
  payload,
});
export const setIsPopupOpen = (payload) => ({
  type: APP_ACTION.SET_IS_POPUP_OPEN,
  payload,
});
export const setShowIntroVideo = (payload) => ({
  type: APP_ACTION.SET_SHOW_INTRO_VIDEO,
  payload,
});
export const setCurrentTab = (payload) => ({
  type: APP_ACTION.SET_CURRENT_TAB,
  payload,
});
export const setConversationId = (payload) => ({
  type: APP_ACTION.SET_CONVERSATION_ID,
  payload,
});
